import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export enum OptionsListState {
  Default = 'default',
  Warning = 'warning',
  Completed = 'completed',
}

export interface Option {
  title: string;
  subtitle: string;
  state: OptionsListState;
}

@Component({
  selector: 'options-list',
  templateUrl: './options-list.component.html',
  styleUrls: ['./options-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptionsListComponent {
  @Input() options: Option[];

  readonly optionsListState = OptionsListState;
}
